import { appConfig } from 'modules/app-config';

import { createAxiosInstance } from './api';

const hubspotApi = createAxiosInstance({ baseURL: appConfig.hubspotApiBaseUrl });

export { hubspotApi };
